const $ = window.$;
window.alerts = {};

export default function(id, hfID) {
	// id = client id of outermost element
	// hfID = id of the HiddenField this alert is associated with
	window.alerts[id] = this;

	this.id = id;
	this.$outer = $('#' + this.id);
	this.$close = this.$outer.find('.js-alert-close');
	this.hf = document.getElementById(hfID);

	this.dismiss = function() {
		this.$outer.remove();
		this.hf.value = '';
	};

	var _cacheSelectors = function() {
		this.$outer = $('#' + this.id);
		this.$text = this.$outer.find('.js-text');
		this.$close = this.$outer.find('.js-alert-close');
		this.hf = document.getElementById(hfID);

		if (!this.id) {
			throw new Error('No element found for id: ' + this.id);
		}
		if (this.hf === null) {
			throw new Error('Alert - ' + this.id + ' No hidden field found for id ' + hfID);
		}
	};

	this.init = function() {
		_cacheSelectors.call(this);
	};

	this.update = function() {
		_cacheSelectors.call(this);
	};
}

window.registerAlert = function(id, hfID) {
	var a;
	if (id in window.alerts) {
		window.alerts[id].update();
		return;
	} else {
		a = new window.Alert(id, hfID);
		if (document.readyState === 'complete') {
			a.init();
		} else {
			$(window).on('load', function() {
				a.init();
			});
		}

		return a;
	}
};

$(document).on('click', '.js-alert-close', function() {
	window.alerts[$(this).attr('data-target')].dismiss();
});